import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const cookies = document.cookie;
  // Check if user is authenticated by looking for token in localStorage
  const isAuthenticated = localStorage.getItem("authToken");

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
